<template>
    <ItemNotFoundState v-if="notFound" :objectName="'Test'">
        <template #backButton>
            <BackButton
                v-if="goToTestFromSeminar"
                :target="{name: 'SeminarDetail', params: {seminarId: seminar.id ? seminar.id : 'new'}}"
            >
              {{ $t('gamification.seminar') }}
            </BackButton>
            <BackButton
                :target="{name: 'Gamification', params: {subjectId: subjectId}, query: {tab: 'tests'}}">
              {{ $t('gamification.tests') }}
            </BackButton>
        </template>
    </ItemNotFoundState>
    <Loading v-else-if="isLoading"></Loading>
    <v-container v-else>
      <QuestionsListDialog
          :is-open="showQuestionListDialog"
          :initial-selected-questions="this.getTest.questions"
          @close="showQuestionListDialog = false"
          @save-options="args => onSaveQuestionListDialog(args.questions)"
      />
      <crafting-question-dialog
          :question-id="editQuestion.id"
          :show-dialog="editQuestion.show"
          :subject-id="getSubject.id"
          @close="closeCraftingQuestionDialog"
      />
      <delete-dialog
          :method="deleteTest"
          :loading="deleteDialog.loading"
          :dialog="deleteDialog.show"
          v-on:childToParent="deleteDialog.show = false"
      />

      <BackButton
          v-if="goToTestFromSeminar"
          :target="{name: 'SeminarDetail', params: {seminarId: seminar.id ? seminar.id : 'new'}}"
      >
        {{ $t('gamification.seminar') }}
      </BackButton>
      <BackButton
          v-else
          :target="{name: 'Gamification', params: {subjectId: subjectId}, query: {tab: 'tests'}}">
        {{ $t('gamification.tests') }}
      </BackButton>
      <ModuleHeader data-cy="module-header">
        <h1> {{ isNew ? $t('gamification.add_test') : $t('gamification.edit_test') }}</h1>
        <div v-if="isNew">
          <SaveButton @click="save" :disabled="saveButtonDisabled">{{ $t('gamification.save')}}</SaveButton>
        </div>
        <div v-else>
          <v-btn v-if="!goToTestFromSeminar" @click="deleteDialog.show = true" variant="text" color="error" rounded class="mr-5">{{ $t('gamification.delete')}}</v-btn>
          <SaveButton @click="save" :disabled="updateButtonDisabled" :is-saving="this.isSaving">{{ $t('gamification.save')}}</SaveButton>
        </div>

      </ModuleHeader>
      <v-row>
        <v-col>
          <v-text-field v-model.trim="this.getTest.name" :rules="[required_rule]" :label="$t('gamification.test_name')" color="primary" variant="underlined" />
        </v-col>
        <v-col>
          <v-text-field :model-value="this.getSubject.name" :disabled="true" :label="$t('gamification.subject')" variant="underlined" />
        </v-col>
      </v-row>
      <h2>{{ $t('gamification.test_icon')}}</h2>
      <v-row class="pt-2">
        <v-col sm="3" md="3" lg="2" xl="2" xxl="2" :key="index" v-for="(image,index) in this.images">
          <div
              @click="updateImage(image)"
              :class="`image-border cursor-pointer ${this.getTest.imageId === image.id && 'image-border-active'}`"
          >
            <v-img
                :src="image.imageUrl"
                width="50px"
                height="50px"
            />
          </div>

        </v-col>
        <v-col cols="12">
          <v-btn
              v-if="showExpandButton"
              @click="onlyFirstRow = !onlyFirstRow"
              color="primary"
              rounded
              variant="outlined"
          >
            {{onlyFirstRow ? $t('gamification.more_icons') : $t('gamification.hide_icons')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="justify-space-between">
        <v-col>
          <h2>{{ $t('gamification.questions') }}</h2>
          <p v-if="getTest.questions.length === 0" class="font-weight-light text-grey-darken-1">{{ $t('gamification.test_one_question') }}</p>
        </v-col>
        <v-col cols="auto">
          <PrimaryButton @click="showQuestionListDialog = true">{{ $t('gamification.add_question') }}</PrimaryButton>
        </v-col>
      </v-row>
      <div v-if="getTest.questions.length > 0">
        <div class="text-primary font-weight-bold">{{ `${getTest.questions.length} ${getTest.questions.length === 1 ? $t('gamification.question').toLowerCase() : $t('gamification.questions').toLowerCase()}`}}</div>
      </div>
      <draggable
          v-show="true"
          :list="this.getTest.questions"
          ghostClass="ghost"
          :move="moved"
          handle=".drag-handle"
      >
        <template v-for="(item, index) in this.getTest.questions" :key="item.id">
          <div class="d-flex align-center justify-space-between px-5 py-3 mt-2 border draggable-item-shadow">
            <div class="d-flex ga-5 align-center">
              <v-icon class="text-grey-lighten-1 cursor-move drag-handle">drag_handle</v-icon>
              {{index + 1}}.
              <span> {{ item.text }}</span>
            </div>
            <div class="d-flex ga-5 align-center">
              <v-icon @click="openCraftingQuestionDialog(item.id)" class="cursor-pointer" color="#6D7278">edit</v-icon>
              <v-icon @click="removeFromList(item.id)" class="cursor-pointer" color="red">delete_outline</v-icon>
            </div>
          </div>
        </template>
      </draggable>

    </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ModuleHeader from "@/components/layout/ModuleHeader";
import BackButton from "@/components/layout/BackButton";
import SaveButton from "@/components/buttons/SaveButton";
import Loading from "@/components/Loading";
import { VueDraggableNext } from 'vue-draggable-next'
import ItemNotFoundState from '@/components/states/ItemNotFoundState.vue';
import moment from "moment/moment";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import QuestionsListDialog from "@/components/gamification/question/QuestionsListDialog.vue";
import _ from 'lodash';
import DeleteDialog from "@/components/map/DeleteDialog.vue";
import CraftingQuestionDialog from "@/components/gamification/question/CraftingQuestionDialog.vue";


export default {
    name: "TestDetail",

    components: {
      CraftingQuestionDialog,
      DeleteDialog,
      QuestionsListDialog,
      PrimaryButton,
        ModuleHeader,
        BackButton,
        SaveButton,
        Loading,
        draggable: VueDraggableNext,
        ItemNotFoundState,
    },

    data() {
        return {
            required_rule: value => !!value || this.$t('gamification.required'),
            selectedQuestion: null,
            selectedAnswer: null,
            showCraftingQuestionDialog: false,
            unsavedChanges: false,
            isLoading: false,
            notFound: false,
            onlyFirstRow: true,
            showQuestionListDialog: false,
            editQuestion: {
              id: null,
              show: false
            },
            testCopy: null,
            isSaving: false,
            deleteDialog: {
              show: false,
              loading: false
            }
        }
    },

    async mounted() {
      this.isLoading = true
      const s = await this.fetchSubjectById(this.goToTestFromSeminar ? this.fromSubjectId : this.subjectId)
      this.setSubject(s)
      await this.fetchAllImages()
      if(this.isNew){
        this.prepareNewTest()
        this.getTest.imageId = this.images[0]?.id
      } else {
        await this.fetchTestById(this.testId)
        this.testCopy = JSON.parse(JSON.stringify(this.getTest))
        this.testCopy.questions.forEach((q, index)=> {
          q.order = index + 1
        })
      }
      this.isLoading = false
    },

  computed: {
        ...mapGetters('Tests', ['getTest', 'didLoadTest', 'didLoadedTests', 'getEmptyTest', 'getImages',]),
        ...mapGetters('Questions', ['didLoadedQuestions', 'getQuestionsBySubjectId', 'getQuestionById', 'getQuestionsByTestId']),
        ...mapGetters('Subjects', ['getSubject']),
        ...mapGetters('SubjectCategories', ['getCategoriesBySubjectId', 'getCategoryByName']),
        ...mapGetters('Seminars',['goToTestFromSeminar','seminar','fromSubjectId']),
        ...mapGetters('Activities',['testActivityForm']),

        testId() {
            const urlId = this.$route.params.testId;
            return urlId === "new" ? null : Number(urlId);
        },

        subjectId() {
            return Number(this.$route.params.subjectId);
        },


        isNew() {
            return this.testId === null;
        },

        imagesPerRow() {
          if (this.$vuetify.display.xlAndUp) return 6
          if (this.$vuetify.display.lgAndUp) return 6
          if (this.$vuetify.display.smAndUp || this.$vuetify.display.mdAndUp) return 4
          else return 2
        },
        saveButtonDisabled(){
          return this.getTest.name.length === 0 ||
              this.getTest.imageId === null ||
              this.getTest.questions.length === 0
        },
        updateButtonDisabled(){
          this.getTest.questions.forEach((q, index)=>{
            q.order = index + 1
          })
          const areQuestionsEqual = _.isEqual(this.getQuestionsMap(this.getTest.questions), this.getQuestionsMap(this.testCopy?.questions || []))
          const areOthersTestInputsEqual = this.getTest.name === this.testCopy?.name && this.getTest.imageId === this.testCopy?.imageId && this.getTest.showAnswers === this.testCopy?.showAnswers
          if(!areQuestionsEqual || !areOthersTestInputsEqual){
            this.madeUnsavedChanges()
          } else {
            this.didSaveChanges()
          }
          return (areQuestionsEqual && areOthersTestInputsEqual) || this.getTest.name.length === 0 || this.getTest.questions.length === 0
        },
        showExpandButton(){
          return this.getImages.length > this.imagesPerRow
        },
        images() {
          if(this.onlyFirstRow && this.getImages.length > this.imagesPerRow){
            return this.getImages.slice(0, this.imagesPerRow)
          } else {
            return this.getImages
          }
        },
    },

      methods: {
        ...mapActions('leavePrevent', ['madeUnsavedChanges', 'didSaveChanges']),
        ...mapActions('Questions', ['fetchAllQuestions']),
        ...mapActions('Tests', ['fetchTestById', 'createTest', 'updateTest', 'deleteTestById', 'fetchAllTests', 'prepareNewTest','fetchAllImages']),
        ...mapActions('Subjects', ['fetchSubjectById', 'setSubject']),
        ...mapActions('SubjectCategories', ['fetchCategoriesBySubjectId']),
        ...mapMutations('Activities',['setTestFormField']),

        updateImage(image){
          this.getTest.imageId = image.id
        },

        moved(evt) {
          this.getTest.questions = evt.relatedContext.list
        },
        onSaveQuestionListDialog(questions){
          this.showQuestionListDialog = false
          this.getTest.questions = questions
        },

        openCraftingQuestionDialog(id){
          this.editQuestion.id = id
          this.editQuestion.show = true
        },
        closeCraftingQuestionDialog(args){
          this.editQuestion.show = false
          const index = this.getTest.questions.findIndex(q => q.id === this.editQuestion.id)
          if(index !== -1 && args){
            this.getTest.questions[index].text = args.questionName
          }
          this.editQuestion.id = null
        },

        removeFromList(id){
          this.getTest.questions = this.getTest.questions.filter(q => q.id !== id)
        },

        getQuestionsMap(questions){
          let questionsMap = {}
          questions.forEach((q, i) => {
            questionsMap[i] = q.id
          })
          return questionsMap
        },

        async deleteTest() {
          this.deleteDialog.loading = true
          this.didSaveChanges()
            await this.deleteTestById(this.testId)
            await this.$router.push({
              name: 'Gamification',
              params: {subjectId: this.subjectId},
              query: {tab: 'tests'}})
          this.deleteDialog.loading = false
          this.deleteDialog.show = false
        },

        async save() {
                this.isSaving = true;
                const body = {
                  ...this.getTest,
                  questions: this.getQuestionsMap(this.getTest.questions)
                }
                if(this.isNew){
                  await this.createTest({item: {
                      ...body,
                      subjectId: this.goToTestFromSeminar ? this.fromSubjectId : this.subjectId,
                    }})
                } else {
                  await this.updateTest({item: body})
                }
                this.didSaveChanges();
                if(this.goToTestFromSeminar){
                  await this.$router.push({
                    name: 'SeminarDetail',
                    params: {seminarId: this.seminar.id ? this.seminar.id : 'new'}
                  })
                } else if (this.isNew) {
                  await this.$router.push({
                    name: 'Gamification',
                    params: {subjectId: this.subjectId},
                    query: {tab: 'tests'}})
                }
                this.isSaving = false;
        },
        changeWatch() {
            this.madeUnsavedChanges();
        },

        formatDateTime(timestamp) {
            return moment(timestamp).format('lll')
        },


    }
}
</script>

<style scoped>
.image-border {
  border: 1px solid #CCCCCC;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 80px;
}

.image-border-active {
  border: 2px solid #78BE13;
}

.ghost {
  opacity: 70%;
  background-color: rgba(120, 190, 19, 0.09);
}
.draggable-item-shadow {
  box-shadow: 2px 2px 3px #e8e8e8;
}
</style>